import React, { useEffect, useContext } from "react";
import Fade from "@material-ui/core/Fade";
import Slider from "react-slick";
import { BotaoMenor } from "../StyledComponent";
import { useHistory } from "react-router-dom";
import { ReactComponent as Feed } from "../../assets/novosicones/Destaques/Feed.svg";
import LogoDirecional from "../../assets/novosicones/SeletorImoveis/Direcional_RGB.png";
import LogoRiva from "../../assets/novosicones/SeletorImoveis/RivaX_PNG_colorida.png";
import { ContextDestaques } from "../../services/destaques";
import FormatDate from "../../Utils/formatDate";

import changeImageUrl from "../../Utils/changeUrl";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./styles.scss";

const Destaques = ({ tema }) => {
  const { loading, loadDestaques, allDestaques } = useContext(ContextDestaques);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const history = useHistory();

  useEffect(() => {
    if (!allDestaques?.data?.length) loadDestaques();
  }, []);

  const lerMais = (idSelecionado) => {
    history.push({
      pathname: "/destaques",
      state: {
        destaques: allDestaques.data,
        idSelecionado: idSelecionado,
      },
    });
  };

  if (loading) return "";

  if (allDestaques.data?.length == 0 || allDestaques.data == undefined)
    return <p style={{ fontWeight: "900" }}>Nenhum destaque disponível.</p>;

  return (
    <Fade in>
      <div className="contentManagement">
        <Slider {...settings}>
          {allDestaques.data.map((destaque, index) => {
            return (
              <div className="centralized contentManagement__item" key={index}>
                {changeImageUrl(destaque?.Imagem) && (
                  <div className="contentManagement__item__banner">
                    <img
                      src={changeImageUrl(destaque?.Imagem)}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          tema?.tipo == "Direcional"
                            ? LogoDirecional
                            : LogoRiva;
                        e.target.parentElement.className =
                          "contentManagement__item__noImage centralized";
                        e.target.parentElement.style = `border: 2px solid ${tema.primaryColor}`;
                      }}
                      alt={destaque?.Titulo}
                      loading="lazy"
                    />
                  </div>
                )}

                {!changeImageUrl(destaque?.Imagem) && (
                  <div
                    className="contentManagement__item__noImage centralized"
                    style={{ border: `2px solid ${tema.primaryColor}` }}
                  >
                    {tema?.tipo == "Direcional" && (
                      <img src={LogoDirecional} alt="Direcional" />
                    )}
                    {tema?.tipo !== "Direcional" && (
                      <img src={LogoRiva} alt="Riva" />
                    )}
                  </div>
                )}

                <div className="centralized-column contentManagement__item__content">
                  <div className="centralized-column contentManagement__item__content__inner">
                    <div
                      className="centralized-space-between"
                      style={{ width: "100%" }}
                    >
                      <div className="centralized">
                        <Feed style={{ fill: tema.primaryColor }} />
                        <span
                          style={{
                            color: tema.primaryColor,
                            marginLeft: "15px",
                            fontWeight: "900",
                          }}
                        >
                          DESTAQUES
                        </span>
                      </div>
                      <span
                        style={{
                          color: tema.primaryColor,
                          marginLeft: "15px",
                          fontWeight: "900",
                        }}
                      >
                        {FormatDate(destaque?.CreatedDate)}
                      </span>
                    </div>
                    <p className="contentManagement__item__content__inner__titulo">
                      {destaque?.Titulo ?? ""}
                    </p>
                    <p className="contentManagement__item__content__inner__texto">
                      {destaque.Resumo
                        ? destaque.Resumo.slice(0, 50) + "..."
                        : ""}
                    </p>
                    <BotaoMenor
                      bg={tema.primaryColor}
                      borda={tema.primaryColor}
                      onClick={(e) => {
                        e.preventDefault();
                        lerMais(index);
                      }}
                      id={`btnDestaqueLerMais${index}`}
                    >
                      LER MAIS
                    </BotaoMenor>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </Fade>
  );
};

export default Destaques;
